<template>
  <!-- MODAL DEL RESUMEN DE CREDITOS -->
  <div
    class="modal fade"
    id="resumenCredito"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="resumenCreditoLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered"
    >
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title display-0" id="resumenCreditoLabel">
            Resumen Crédito
          </p>
          <!-- <router-link v-if="this.modoThanos === true" class="btn btn-info text-center ti-angle-left"
              to="/soli-credito/:solicitanteId" data-bs-dismiss="modal"> Editar Credito</router-link> -->

          <div class="modal-actions">
            <button
            @click="redirect"
            class="btn btn-resumen-primary"
            v-if="this.modoThanos === true"
          >
            Editar Crédito
            </button>

            <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="this.readyVerMas" id="creditosResumen" class="container">
            <div class="row g-3 resumen-layout">
              <div class="col-12 col-lg-7">
                <div class="container cont-ver">
                  <div class="row">
                    <div class="col-lg-9 col-12">
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Nombre del Cliente</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.cliente?.nombres }}
                          {{ this.verMasData.cliente?.apellidos }}
                        </p>
                      </div>
                      <div
                        v-if="
                          (this.verMasData.cliente.apellidos != ''
                            ? this.verMasData.cliente.nombres +
                              ` ` +
                              this.verMasData.cliente.apellidos
                            : this.verMasData.cliente?.nombres) !=
                          this.verMasData.infoRegistro?.nombre
                        "
                        class="row text-danger d-flex"
                      >
                        <!-- <strong v-if="this.verMasData.infoRegistro.foto" class="col-6 col-lg-4 titulo">Nombre RNP</strong> -->
                        <strong
                          v-if="this.verMasData.infoRegistro?.nombre"
                          class="col-6 col-lg-4 titulo"
                          >Nombre RNP</strong
                        >
                        <!-- <p v-if="this.verMasData.infoRegistro.foto" class="col-6 col-lg-8 contenido-ver">{{ -->
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.infoRegistro?.nombre }}
                          <i v-if="this.verMasData.infoRegistro?.nombre"
                            class="fa-regular  fa-square-caret-down"
                            @click="detailsRnp()"
                            style="color: dark; cursor: pointer"
                          ></i>
                        </p>
                      </div>

                      <!-- *********************************** -->
                      <div
                        v-if="
                          this.verMasData.infoRegistro?.nombre &&
                          this.readyInfoRegistro
                        "
                        class="container-fluid info-rnp"
                      >
                        <strong class="noMargen">Residencia RNP</strong>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo"
                            >Despartamento</strong
                          >
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrDeptoResidencia
                            }}
                          </p>
                        </div>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo"
                            >Municipio</strong
                          >
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrMunicResidencia
                            }}
                          </p>
                        </div>

                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo">Barrio</strong>
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrBarrioResidencia
                            }}
                          </p>
                        </div>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo"
                            >Direccion Residencia</strong
                          >
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.direccionResidencia
                            }}
                          </p>
                        </div>

                        <strong class="noMargen">Nacimiento RNP</strong>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo">
                            Departamento
                          </strong>
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrDeptoNacimiento
                            }}
                          </p>
                        </div>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo"
                            >Municipio
                          </strong>
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrMunicNacimiento
                            }}
                          </p>
                        </div>
                        <div class="row text-danger">
                          <strong class="col-6 col-lg-4 titulo">Barrio </strong>
                          <p class="col-6 col-lg-8 contenido-ver">
                            {{
                              this.verMasData.infoRegistro.descrBarrioNacimiento
                            }}
                          </p>
                        </div>
                      </div>
                      <!-- ******************************** -->
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo">Identidad</strong>
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.cliente?.dni }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo">Teléfono</strong>
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.cliente?.telefono }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo">Producto Financiero</strong>
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.solicitud?.producto }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Frecuencia de pago</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.solicitud?.frecuenciaPago }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo notranslate"
                          >Tasa de Interes(Anual)</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.solicitud?.interes }} %
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo notranslate"
                          >Tasa de Int. Mora(Anual)</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.solicitud?.tasaMora }} %
                        </p>
                      </div>
                      <div class="row">
                        <strong class="notranslate col-6 col-lg-4 titulo"
                          >Plazo en meses</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData.solicitud?.plazoPago }} meses
                        </p>
                      </div>

                      <hr />
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >No. Prestamo</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData?.noPrestamo }}
                        </p>
                      </div>
                      <div
                        v-if="this.verMasData.noPrestamoOriginal != ''"
                        class="row"
                      >
                        <strong class="col-6 col-lg-4 titulo"
                          >No. Prestamo Original</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData?.noPrestamoOriginal }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Estado Crédito</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ this.verMasData?.estado }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Fecha de Otorgamiento</strong
                        >
                        <p class="notranslate col-6 col-lg-8 contenido-ver">
                          {{ dateFormat(this.verMasData?.fechaOtorgamiento) }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Fecha de Vencimiento</strong
                        >
                        <p class="notranslate col-6 col-lg-8 contenido-ver">
                          {{ dateFormat(this.verMasData?.fechaVencimiento) }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Fecha Última de pago</strong
                        >
                        <p class="notranslate col-6 col-lg-8 contenido-ver">
                          {{ dateFormat(this.verMasData?.fechaUltimaPago) }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Monto Aprobado</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{
                            formatoNumero(this.verMasData?.montoOtorgado)
                          }}
                          {{ this.moneda }}
                        </p>
                      </div>

                      <!-- <div class="row">
                      <strong class="col-12 col-lg-4 titulo">Monto Otorgado</strong>
                      <p class="col-12 col-lg-8 contenido-ver">{{ this.verMasData.montoOtorgadoReal ? this.verMasData?.montoOtorgadoReal : '' }} {{
                        this.moneda }}</p>
                    </div> -->
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Cuotas Pagadas</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{
                            this.verMasData.noCuotas
                              ? this.verMasData?.noCuotas - 1
                              : ""
                          }}
                          Cuotas
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo text-danger"
                          >Saldo Arreglo Interes</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{
                            formatoNumero(
                              this.verMasData?.saldoArrInteresPagado -
                                this.verMasData?.totalArrInteresPagado
                            )
                          }}
                          {{ this.moneda }}
                        </p>
                      </div>
                      <div class="row">
                        <strong class="col-6 col-lg-4 titulo"
                          >Saldo de Capital</strong
                        >
                        <p class="col-6 col-lg-8 contenido-ver">
                          {{ formatoNumero(this.verMasData?.saldo) }}
                          {{ this.moneda }}
                        </p>
                      </div>
                      <!-- <div class="row">
                      <strong class="col-12 col-lg-4 titulo">Identidad</strong>
                      <p class="col-12 col-lg-6 contenido-ver">{{ this.verMasData.cliente?.dni }}</p>
                    </div>
                    <div class="row">
                      <strong class="col-12 col-lg-4 titulo">Identidad</strong>
                      <p class="col-12 col-lg-6 contenido-ver">{{ this.verMasData.cliente?.dni }}</p>
                    </div> -->
                    </div>
                    <div class="col-lg-3 col-12">
                      <img
                        v-if="this.verMasData.infoRegistro.foto"
                        class="text-center"
                        style="width: 130px; border-radius: 5px"
                        :src="
                          'data:image/png;base64,' +
                          verMasData?.infoRegistro.foto
                        "
                        alt="Foto Persona"
                      />
                      <div v-else-if="this.verMasData.infoRegistro.foto == ''">
                        <div class="d-flex justify-content-center"></div>
                      </div>
                      <div v-else>
                        <div class="d-flex justify-content-center">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-3 resumen-status-row">
                  <strong
                    class="text-success"
                    v-if="this.esLocalizable === 'true'"
                    >Es Localizable</strong
                  >
                  <strong class="text-danger" v-else>No es Localizable</strong>
                  <div class="ms-5">
                    <strong>En proceso:</strong> {{ this.estadoProceso }}
                  </div>
                </div>
                <div
                  v-if="this.estadoProcesoBool"
                  class="estado-proceso flex pe-0 pt-0 pb-0 pe-lg-5 pt-lg-2 pb-lg-4"
                >
                  <div class="localizable-options ps-5 ps-lg-5">
                    <div class="form-check">
                      <input
                        v-model="this.esLocalizable"
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        value="true"
                        checked
                      />
                      <label class="form-check-label" for="flexRadioDefault1">
                        Es Localizable
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        v-model="this.esLocalizable"
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        value="false"
                      />
                      <label class="form-check-label" for="flexRadioDefault2">
                        No es Localizable
                      </label>
                    </div>
                  </div>
                  <strong class="mb-0 mb-lg-2"
                    >Selecciona el proceso en el que se encuentra</strong
                  >
                  <select
                    v-model="estadoProceso"
                    class="form-select"
                    aria-label="Default select example"
                  >
                    <option value="EXTRAJUDICIAL">Extrajudicial</option>
                    <option value="JUDICIAL/LEGAL">Judicial/Legal</option>
                    <option value="CASTIGO">
                      Castigo/cartera(Ilocalizables y Fallecidos)
                    </option>
                    <option value="IRREGULAR">Irregular</option>
                    <option value="NORMAL">Normal</option>
                  </select>

                  <button
                    class="btn btn-resumen-primary mt-3 mt-lg-0"
                    @click="guardarEstadoProceso()"
                    type="button"
                  >
                    Guardar
                  </button>
                </div>
              </div>

              <div class="col-12 col-lg-5 ver-mas-right">
                <!-- {{ this.verMasData.infoRegistro.foto }} -->

                <div v-if="this.readyVerMas" class="total-pagado">
                  <h3>Total Pagado</h3>

                  <div
                    v-if="comprobarEstado(this.verMasData?.estado)"
                    class="paid-group d-flex flex-column align-items-center"
                  >
                    <div class="pagado d-flex align-items-center">
                      <h4>Capital Pagado</h4>
                      <p class="ms-3">
                        {{ formatoNumero(this.verMasData?.capitalAcumulado - this.convertirANoNegativo(this.verMasData.capitalAcumulado -
                              this.verMasData.montoOtorgado)) }}
                        {{ this.moneda }}
                      </p>
                    </div>
                    <!-- <div  class="pagado d-flex align-items-center">
                      <h4>Capital Pagado </h4>
                      <p class="ms-3">{{ formatoNumero(this.verMasData?.capitalAcumulado) }} {{ this.moneda }}</p>
                    </div> -->
                    <div class="pagado d-flex align-items-center">
                      <h4>Otros Ingresos</h4>
                      <p class="ms-3">
                        {{
                          formatoNumero(
                            this.convertirANoNegativo(this.verMasData.capitalAcumulado -
                              this.verMasData.montoOtorgado)
                          )
                        }}
                        {{ this.moneda }}
                      </p>
                    </div>
                  </div>
                  <div v-else class="paid-group d-flex align-items-center">
                    <div class="pagado d-flex align-items-center">
                      <h4>Capital Pagado</h4>
                      <p class="ms-3">
                        {{ formatoNumero(this.verMasData?.capitalAcumulado) }}
                        {{ this.moneda }}
                      </p>
                    </div>
                  </div>

                  <div class="pagado d-flex align-items-center">
                    <h4>Interes Corriente Pagado</h4>
                    <p class="ms-3">
                      {{ formatoNumero(this.verMasData?.totalInteresPagado) }}
                      {{ this.moneda }}
                    </p>
                  </div>
                  <div class="pagado d-flex align-items-center">
                    <h4>Interes Moratorio Pagado</h4>
                    <p class="ms-3">
                      {{ formatoNumero(this.verMasData?.totalMoraPagada) }}
                      {{ this.moneda }}
                    </p>
                  </div>
                  <div
                    v-if="this.verMasData?.totalArrInteresPagado > 0"
                    class="pagado d-flex align-items-center"
                  >
                    <h4 class="text-danger">Arreglo Interes Pagado</h4>
                    <p class="ms-3">
                      {{
                        formatoNumero(this.verMasData?.totalArrInteresPagado)
                      }}
                      {{ this.moneda }}
                    </p>
                  </div>
                  <div class="pagado d-flex align-items-center">
                    <h4>Total Pagado</h4>
                    <p class="ms-3">
                      {{
                        formatoNumero(
                          this.verMasData?.totalPagado +
                            this.verMasData?.totalArrInteresPagado
                        )
                      }}
                      {{ this.moneda }}
                    </p>
                  </div>
                </div>
                <div class="verificar-cartera">
                  <h4
                    v-if="
                      (this.Coordinacion === true &&
                        this.verMasData.aprobadoJefe === false) ||
                      (this.coordinadorSucursal === true &&
                        this.verMasData.aprobadoCoordinador === false)
                    "
                    class="text-center"
                  >
                    Verificar Cartera
                  </h4>
                  <div class="">
                    <span
                      v-if="
                        this.verMasData.aprobadoCoordinador === false &&
                        this.verMasData.aprobadoJefe === false
                      "
                      class="pendiente text-danger"
                    >
                      <em>
                        <small> Pendiente Revisión por Coordinadores </small>
                      </em>
                    </span>
                    <span
                      v-else-if="this.verMasData.aprobadoCoordinador === false"
                      class="pendiente text-danger"
                    >
                      <em>
                        <small>
                          Pendiente Revisión Por Coordinador de la Sucursal
                        </small>
                      </em>
                    </span>
                    <span
                      v-else-if="this.verMasData.aprobadoJefe === false"
                      class="pendiente text-danger"
                    >
                      <em>
                        <small>
                          Pendiente Revisión Por Jefe de Acceso Financiero
                        </small>
                      </em>
                    </span>
                    <span
                      v-else-if="
                        this.verMasData.aprobadoCoordinador === true &&
                        this.verMasData.aprobadoJefe === true
                      "
                      class="aprobado text-behance"
                    >
                      <em>
                        <small class="d-flex justify-content-between">
                          Verificado ✔

                          <!-- Refinanciamiento oculto temporalmente.
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <input
                              v-if="this.Coordinacion"
                              class="ms-2"
                              type="checkbox"
                              v-model="esRefinanciado"
                              id="flexCheckDefault"
                            />
                            <label
                              v-if="this.esRefinanciado"
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              Refinanciado
                            </label>
                            <label
                              v-else
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              No Refinanciado
                            </label>
                          </div>
                          -->
                        </small>
                      </em>
                    </span>
                    <span>
                      <!-- Es Refinanciado -->
                    </span>
                  </div>
                  <br />
                </div>

                <div
                  class="pt-2 d-flex flex-column justify-content-center align-items-center summary-actions-card"
                >
                  <button
                    v-if="
                      this.coordinadorSucursal === true &&
                      this.verMasData.aprobadoCoordinador === false
                    "
                    id="cordinadorSucursal"
                    @click="comprobarData"
                    class="btn btn-resumen-success mt-4"
                  >
                    Confirmar Data Coordinador
                  </button>
                  <button
                    v-if="
                      this.Coordinacion === true &&
                      this.verMasData.aprobadoJefe === false
                    "
                    id="Coordinacion"
                    @click="comprobarData"
                    class="btn btn-resumen-success mt-4"
                  >
                    Confirmar Data Acceso Financiero
                  </button>
                  <!-- <button v-if="this.Coordinacion === true && this.mayusculasSinEspacios(this.verMasData?.estado) === 'VENCIDO'" -->
                  <div
                    class="row d-flex justify-content-center align-items-stretch admin-controls-row"
                  >
                    <div
                      v-if="this.Coordinacion || this.Admin"
                      class="col-12 col-lg-6 mt-3 mt-lg-0 d-flex justify-content-center align-items-stretch admin-control"
                    >
                      <div class="admin-control-body">
                        <strong class="d-flex justify-content-center admin-control-label"
                          >Estado Crédito
                          </strong
                        >
                        <select
                          v-model="this.verMasData.estado"
                          class="form-select mb-3"
                          aria-label="Default select example"
                        >
                          <option v-if="this.verMasData.estado != 'Legal' && this.verMasData.estado != 'Fallecido' && this.verMasData.estado != 'Devuelto'" :value="this.verMasData.estado">{{this.verMasData.estado}}</option>
                          <option value="Legal">Legal</option>
                          <option value="Fallecido">Fallecido</option>
                          <option value="Devuelto">Devuelto</option>
                        </select>
                      </div>
                      <button
                        @click="
                          cambiarEstado(
                            this.verMasData.id,
                            this.verMasData.estado
                          )
                        "
                        class="ms-1 btn btn-resumen-icon mb-2 d-flex justify-content-center align-items-center"
                      >
                        <i class="bi bi-floppy2"></i>
                      </button>
                    </div>
                    <div
                      v-if="this.Coordinacion || this.Admin"
                      class="col-12 col-lg-6 mt-3 mt-lg-0 d-flex justify-content-center align-items-stretch admin-control"
                    >
                      <div class="admin-control-body">
                        <strong class="d-flex justify-content-center admin-control-label"
                          >Asesor</strong
                        >
                        <select
                          v-model="this.asesor"
                          class="form-select mb-3"
                          aria-label="Default select example"
                        >
                          <option
                            v-for="(asesor, index) in this.asesores"
                            :key="index"
                            :value="asesor.id"
                          >
                            {{ asesor.first_name }}
                            {{ asesor.last_name }}
                          </option>
                        </select>
                      </div>
                      <button
                        @click="cambiarAsesor(this.verMasData.id, this.asesor)"
                        class="ms-1 btn btn-resumen-icon mb-2 d-flex justify-content-center align-items-center"
                      >
                        <i class="bi bi-floppy2"></i>
                      </button>
                    </div>
                    <div
                      v-else-if="this.verMasData.userAdmin"
                      class="col-12 text-center mt-2 mb-2"
                    >
                      Asesor Administrador: {{ this.asesorAdmin }}
                    </div>
                    <div v-else class="col-12 text-center mt-2 mb-2">
                      <p class="text-danger">Falta Asignar Administrador</p>
                    </div>
                  </div>


                                    <div class="files-summary">
                                    <a :href="'/archivos/' + this.verMasData.idSolicitud" class="folder" target="_blank">
                                        <i class="fa-solid fa-folder-open"></i>
                                    </a>
                                    <h4 class="pt-2">Archivos</h4>
                                    <p>{{ this.contadorArchivos }} Archivos</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

          <div v-else class="resumen-loading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div v-if="this.readyVerMas" class="row">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  <i class="fa-solid fa-book me-2"></i> Seguimiento
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  <BitacoraApp
                    :idCredito="this.verMasData.id"
                    :idUsuario="store.user.id"
                    :beneficiario="
                      this.verMasData.cliente?.nombres +
                      ' ' +
                      (this.verMasData.cliente.apellidos != undefined
                        ? this.verMasData.cliente?.apellidos
                        : '')
                    "
                  />
                </div>
              </div>
            </div>
            <!-- Gestion Proceso Legal oculto temporalmente.
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo2"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                 <i class="fa-solid fa-gavel me-2"></i> Gestión Proceso Legal
                </button>
              </h2>
              <div
                id="collapseTwo2"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  
                  <ProcesoLegal
                    :idCredito="Number(this.verMasData.id)"
                    :idUsuario="store.user.id"
                    :idCliente="this.verMasData.cliente?.id"
                    :beneficiario="
                      this.verMasData.cliente?.nombres +
                      ' ' +
                      (this.verMasData.cliente.apellidos != undefined
                        ? this.verMasData.cliente?.apellidos
                        : '')
                    "
                  />
                </div>
              </div>
            </div>
            -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseThree"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseThree"
                >
                  <div class="col-6"><i class="fa-solid fa-money-check-dollar me-2"></i>Historial de Pagos</div>
                  <div
                    id="validar-3"
                    class="d-flex justify-content-end me-3"
                    style="width: 100%"
                  ></div>
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingThree"
              >
                <div class="accordion-body">
                  <div class="d-flex justify-content-between">
                    <button
                      v-if="Admin || Coordinacion"
                      class="btn btn-resumen-primary mb-2"
                      @click="simularPagos()"
                    >
                      Simular Pagos
                    </button>
                  </div>

                  <!-- Acorddion Body -->
                  <div class="col-12">
                    <table class="table col-12">
                      <thead>
                        <tr class="text-center">
                          <th>No.</th>
                          <th>No. Referencia Recibo</th>
                          <th>Monto</th>
                          <th>Fecha Pagado</th>
                          <th class="notranslate">IFI</th>
                          <th>No. Cuenta</th>
                          <th>Imagen</th>
                          <th></th>
                          <!-- <th>Eliminar</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(pago, index) in this.pagos"
                          :key="pago.id"
                          class="text-center"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ pago.noReferenciaRecibo }}</td>
                          <td>
                            {{ formatoNumero(pago.montoPagado) }}
                            {{ this.moneda }}
                            <p
                              v-if="pago.esReadecuado"
                              class="text-primary"
                              style="margin: 0"
                            >
                              Es refinanciamiento
                            </p>
                            <p
                              v-else-if="pago.tipoPago === 'interes'"
                              class="text-primary"
                              style="margin: 0"
                            >
                              Pago Interes
                            </p>
                          </td>
                          <td>{{ dateFormat(pago.fechaPagado) }}</td>
                          <td>{{ pago.ifi }}</td>
                          <td>{{ pago.noCuenta }}</td>

                          <td>
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <pdf-recibo
                                :imgPath="imgPath"
                                :pago="pago"
                                class="me-3"
                              ></pdf-recibo>
                              <button
                                class="receipt-thumb-button"
                                type="button"
                                @click="openReceiptModal(pago)"
                                aria-label="Ver recibo"
                              >
                                <recibo-protegido
                                  :slug="pago.slug"
                                  imgClass="receipt-thumb-img"
                                ></recibo-protegido>
                              </button>
                            </div>
                          </td>
                          <td>
                            <div>
                              <OptionsMenu
                                :onRead="() => handleRead(pago.id)"
                                :onDelete="() => deletePayment(pago.id)"
                              />
                            </div>
                          </td>
                          <!-- <td> <button class="btn btn-primary" style="color: white" @click="eliminarPago(pago.id)"><i class="fa-solid fa-delete-left"></i></button> </td> -->
                        </tr>
                        <tr class="table-secondary">
                          <td></td>
                          <td><strong>Total:</strong></td>
                          <td>
                            {{ this.formatoNumero(this.totalMontoPagado) }}
                            {{ this.moneda }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <a
            v-if="this.verMasData.cliente != undefined"
            :href="`/solicitante/${this.verMasData.cliente.id}`"
            target="_blank"
            class="btn btn-resumen-primary"
            >Datos Beneficiario
          </a>
          <a
            :href="`/solicitud/integrante/${this.verMasData.idSolicitud}`"
            target="_blank"
            class="btn btn-resumen-primary"
            >Datos Solicitud</a
          >
          <button
            type="button"
            class="btn btn-resumen-secondary"
            data-bs-dismiss="modal"
            @click="() => (this.nombreBanco = '')"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->
  <!-- FIN DE MODAL -->

  <div
    v-if="selectedReceiptPayment"
    class="receipt-viewer-backdrop"
    role="dialog"
    aria-modal="true"
    aria-label="Recibo de pago"
    @click.self="closeReceiptModal"
  >
    <div class="receipt-viewer">
      <div class="receipt-viewer-header">
        <div>
          <p class="receipt-eyebrow mb-1">Recibo de pago</p>
          <h5 class="receipt-title mb-0">
            {{ selectedReceiptPayment.noReferenciaRecibo || 'Sin referencia' }}
          </h5>
        </div>
        <button
          type="button"
          class="receipt-close"
          aria-label="Cerrar"
          @click="closeReceiptModal"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="receipt-meta">
        <span>{{ dateFormat(selectedReceiptPayment.fechaPagado) }}</span>
        <span>{{ formatoNumero(selectedReceiptPayment.montoPagado) }} {{ moneda }}</span>
        <span>{{ selectedReceiptPayment.ifi }}</span>
      </div>
      <div class="receipt-image-shell">
        <recibo-protegido
          :slug="selectedReceiptPayment.slug"
          imgClass="receipt-full-img"
        ></recibo-protegido>
      </div>
    </div>
  </div>
</template>

<script>
import OptionsMenu from "./OptionsMenu.vue";
import PdfRecibo from "./Pdf-Recibo.vue";
import ReciboProtegido from "./ReciboProtegido.vue";
import BitacoraApp from "./BitacoraApp.vue";
// Gestion Proceso Legal oculto temporalmente.
// import ProcesoLegal from "./ProcesoLegal.vue";

export default {
  name: "ResumenCreditoModal",
  components: {
    PdfRecibo,
    ReciboProtegido,
    OptionsMenu,
    BitacoraApp,
    // Gestion Proceso Legal oculto temporalmente.
    // ProcesoLegal,
  },
  props: {
    modalState: {
      type: Object,
      required: true,
    },
    actions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedReceiptPayment: null,
    };
  },
  computed: {
    readyVerMas() {
      return this.modalState.readyVerMas;
    },
    verMasData() {
      return this.modalState.verMasData || {};
    },
    readyInfoRegistro() {
      return this.modalState.readyInfoRegistro;
    },
    modoThanos() {
      return this.modalState.modoThanos;
    },
    moneda() {
      return this.modalState.moneda;
    },
    imgPath() {
      return this.modalState.imgPath;
    },
    esLocalizable: {
      get() {
        return this.modalState.esLocalizable;
      },
      set(value) {
        this.setState("esLocalizable", value);
      },
    },
    estadoProceso: {
      get() {
        return this.modalState.estadoProceso;
      },
      set(value) {
        this.setState("estadoProceso", value);
      },
    },
    estadoProcesoBool() {
      return this.modalState.estadoProcesoBool;
    },
    Coordinacion() {
      return this.modalState.Coordinacion;
    },
    coordinadorSucursal() {
      return this.modalState.coordinadorSucursal;
    },
    Admin() {
      return this.modalState.Admin;
    },
    esRefinanciado: {
      get() {
        return this.modalState.esRefinanciado;
      },
      set(value) {
        this.setState("esRefinanciado", value);
      },
    },
    estadoSeleccionado() {
      return this.modalState.estadoSeleccionado;
    },
    asesor: {
      get() {
        return this.modalState.asesor;
      },
      set(value) {
        this.setState("asesor", value);
      },
    },
    asesores() {
      return this.modalState.asesores || [];
    },
    asesorAdmin() {
      return this.modalState.asesorAdmin;
    },
    contadorArchivos() {
      return this.modalState.contadorArchivos;
    },
    pagos() {
      return this.modalState.pagos || [];
    },
    totalMontoPagado() {
      return this.modalState.totalMontoPagado;
    },
    store() {
      return this.modalState.store || { user: {} };
    },
    nombreBanco: {
      get() {
        return this.modalState.nombreBanco;
      },
      set(value) {
        this.setState("nombreBanco", value);
      },
    },
  },
  methods: {
    setState(key, value) {
      if (this.actions.setState) {
        this.actions.setState(key, value);
      }
    },
    dateFormat(param) {
      return this.actions.dateFormat ? this.actions.dateFormat(param) : "";
    },
    formatoNumero(numero) {
      return this.actions.formatoNumero ? this.actions.formatoNumero(numero) : numero;
    },
    detailsRnp() {
      return this.actions.detailsRnp ? this.actions.detailsRnp() : null;
    },
    redirect() {
      return this.actions.redirect ? this.actions.redirect() : null;
    },
    guardarEstadoProceso() {
      return this.actions.guardarEstadoProceso
        ? this.actions.guardarEstadoProceso()
        : null;
    },
    comprobarEstado(estado) {
      return this.actions.comprobarEstado
        ? this.actions.comprobarEstado(estado)
        : false;
    },
    convertirANoNegativo(numero) {
      return this.actions.convertirANoNegativo
        ? this.actions.convertirANoNegativo(numero)
        : numero;
    },
    comprobarData(event) {
      return this.actions.comprobarData ? this.actions.comprobarData(event) : null;
    },
    cambiarEstado(idCredito, estado) {
      return this.actions.cambiarEstado
        ? this.actions.cambiarEstado(idCredito, estado)
        : null;
    },
    cambiarAsesor(idCredito, idAsesor) {
      return this.actions.cambiarAsesor
        ? this.actions.cambiarAsesor(idCredito, idAsesor)
        : null;
    },
    simularPagos() {
      return this.actions.simularPagos ? this.actions.simularPagos() : null;
    },
    handleRead(idPago) {
      return this.actions.handleRead ? this.actions.handleRead(idPago) : null;
    },
    deletePayment(idPago) {
      return this.actions.deletePayment ? this.actions.deletePayment(idPago) : null;
    },
    openReceiptModal(pago) {
      this.selectedReceiptPayment = pago;
    },
    closeReceiptModal() {
      this.selectedReceiptPayment = null;
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: min(1240px, calc(100vw - 1.25rem));
  width: min(1240px, calc(100vw - 1.25rem));
  min-height: calc(100dvh - 1rem);
  margin: 0.5rem auto;
  display: flex;
  align-items: center;
}

.modal-content {
  overflow: hidden;
  height: min(760px, calc(100dvh - 1rem));
  max-height: calc(100dvh - 1rem);
  border: none;
  border-radius: 24px;
  background: #f7f8fb;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);
}

.modal-header {
  gap: 12px;
  padding: 8px 12px;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(120deg, #f8fafc 0%, #eef2f7 100%);
}

.modal-title {
  color: #111827;
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin: 0;
}

.modal-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
}

.modal-header .btn-close {
  margin: 0;
  width: 30px;
  height: 30px;
  padding: 6px;
  border-radius: 6px;
  opacity: 0.72;
  filter: none;
}

.modal-body {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;
  background: #f7f8fb;
}

.modal-footer {
  gap: 6px;
  padding: 6px 12px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 6px 12px;
}

.btn-resumen-primary {
  color: #ffffff;
  border-color: #2563eb;
  background: #2563eb;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);
}

.btn-resumen-primary:hover,
.btn-resumen-primary:focus,
.btn-resumen-primary:active {
  color: #ffffff;
  border-color: #1d4ed8;
  background: #1d4ed8;
}

.btn-resumen-success {
  color: #ffffff;
  border-color: #0f766e;
  background: #0f766e;
  box-shadow: 0 8px 18px rgba(15, 118, 110, 0.18);
}

.btn-resumen-success:hover,
.btn-resumen-success:focus,
.btn-resumen-success:active {
  color: #ffffff;
  border-color: #0d665f;
  background: #0d665f;
}

.btn-resumen-secondary {
  color: #334155;
  border-color: #cbd5e1;
  background: #ffffff;
}

.btn-resumen-secondary:hover,
.btn-resumen-secondary:focus,
.btn-resumen-secondary:active {
  color: #111827;
  border-color: #94a3b8;
  background: #f8fafc;
}

.btn-resumen-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  color: #ffffff;
  border-color: #0f766e;
  background: #0f766e;
  box-shadow: 0 8px 18px rgba(15, 118, 110, 0.16);
}

#creditosResumen {
  max-width: 100%;
  padding-right: 0;
  padding-left: 0;
}

.resumen-layout {
  --bs-gutter-x: 0.65rem;
  --bs-gutter-y: 0.65rem;
}

.resumen-loading {
  display: flex;
  min-height: 360px;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.noMargen {
  margin: 0 0 6px;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 800;
}

.cont-ver {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.cont-ver .col-lg-9 > .row {
  min-height: 24px;
  align-items: center;
  justify-content: space-between;
  padding: 1px 6px;
  border-bottom: 0;
  border-radius: 7px;
  transition: background-color 0.16s ease;
}

.cont-ver .col-lg-9 > .row:hover {
  background: #f1f3f6;
}

.cont-ver hr {
  margin: 6px 0;
  color: #d1d5db;
  opacity: 1;
}

.cont-ver img {
  width: min(130px, 100%) !important;
  border: 1px solid #e5e7eb;
  border-radius: 12px !important;
  background: #f8fafc;
  object-fit: cover;
}

.titulo {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.15;
  padding-right: 10px;
  white-space: normal;
}

.contenido-ver {
  flex: 1 1 auto;
  color: #111827;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 0;
  padding-left: 8px !important;
  text-align: right;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.info-rnp {
  padding: 8px;
  margin: 6px 0;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fff7f7;
}

.info-rnp .row {
  min-height: 26px;
}

.info-rnp .row:hover {
  background: #fff1f1;
}

.resumen-status-row {
  align-items: center;
  gap: 10px;
  padding: 6px 9px;
  margin-bottom: 8px !important;
  border: 1px solid #e5e7eb;
  border-radius: 11px;
  background: #ffffff;
  color: #334155;
  font-size: 0.78rem;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.resumen-status-row .ms-5 {
  margin-left: 0 !important;
}

.resumen-status-row > strong {
  margin-left: 8px;
}

.estado-proceso {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 8px !important;
  margin-bottom: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.estado-proceso .ps-5 {
  padding-left: 0 !important;
}

.localizable-options {
  min-width: 150px;
  margin-left: 12px;
  padding-left: 0 !important;
}

.localizable-options .form-check {
  margin-bottom: 3px;
  padding-left: 1.45rem;
  text-align: left;
}

.estado-proceso strong {
  color: #475569;
  font-size: 0.78rem;
}

.form-control,
.form-select {
  height: 28px;
  min-height: 28px;
  padding: 3px 8px;
  color: #334155;
  font-size: 11.5px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}

.form-control:focus,
.form-select:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 0.16rem rgba(15, 23, 42, 0.08);
}

.total-pagado {
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-top: 3px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  color: #111827;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.total-pagado h3 {
  margin-bottom: 6px;
  color: #111827;
  font-size: 0.95rem;
  font-weight: 700;
}

.pagado {
  width: 100%;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 8px;
  margin-bottom: 5px;
  border: 1px solid #edf2f7;
  border-radius: 9px;
  background: #f9fafb;
}

.paid-group {
  width: 100%;
  gap: 5px;
}

.pagado h4 {
  margin: 0;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.15;
}

.pagado p {
  margin: 0 !important;
  color: #111827;
  font-size: 0.84rem;
  font-weight: 800;
  line-height: 1.15;
  text-align: right;
}

.verificar-cartera,
.ver-mas-right > .pt-2 {
  padding: 8px !important;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.verificar-cartera {
  min-height: 72px;
}

.verificar-cartera h4 {
  margin-bottom: 6px;
  color: #111827;
  font-size: 0.9rem;
  font-weight: 700;
}

.pendiente,
.aprobado {
  display: flex;
  min-height: 46px;
  align-items: center;
  padding: 7px 9px;
  border-radius: 9px;
  background: #f9fafb;
  font-weight: 700;
  overflow: visible;
}

.pendiente em,
.aprobado em {
  width: 100%;
  font-style: normal;
}

.pendiente small,
.aprobado small {
  width: 100%;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: inherit;
  font-size: 0.76rem;
  line-height: 1.2;
  white-space: normal;
}

.aprobado small > div {
  flex: 0 0 auto;
  min-height: 28px;
  padding: 3px 8px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1e40af;
  font-weight: 800;
}

.aprobado .form-check-label {
  margin: 0;
  white-space: nowrap;
}

.aprobado input[type="checkbox"] {
  width: 14px;
  height: 14px;
  margin-left: 0 !important;
  margin-right: 5px;
}

.summary-actions-card {
  gap: 8px;
}

.admin-controls-row {
  width: 100%;
  margin-right: 0;
  margin-left: 0;
  row-gap: 8px;
}

.admin-control {
  padding-right: 4px;
  padding-left: 4px;
  gap: 6px;
}

.admin-control-body {
  display: flex;
  width: 100%;
  min-height: 86px;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
}

.admin-control-label {
  min-height: 28px;
  align-items: center;
  color: #475569;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
  overflow-wrap: anywhere;
}

.admin-control .form-select {
  margin-bottom: 0 !important;
}

.admin-control .btn-resumen-icon {
  flex: 0 0 32px;
  align-self: center;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
}

.folder {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #2563eb;
  text-decoration: none;
}

.folder i {
  font-size: 1.2rem;
}

.files-summary {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
}

.ver-mas-right h4.pt-2 {
  margin: 0;
  padding-top: 2px !important;
  color: #111827;
  font-size: 0.9rem;
  font-weight: 700;
}

.ver-mas-right p {
  margin: 0;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 700;
}

.accordion-item {
  overflow: hidden;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.accordion-button {
  min-height: 42px;
  padding: 9px 12px;
  color: #111827 !important;
  font-size: 0.88rem;
  font-weight: 700 !important;
  background: #f3f5f8 !important;
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  color: #111827 !important;
  background: #e5e7eb !important;
}

.accordion-body {
  padding: 10px;
  background: #ffffff;
}

.table {
  margin-bottom: 0;
  font-size: 0.78rem;
}

.table thead th {
  background: #f3f5f8;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.74rem;
}

.table th,
.table td {
  vertical-align: middle;
}

.receipt-thumb-button {
  width: 46px;
  height: 46px;
  padding: 0;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 50%;
  background: #f8fafc;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  cursor: pointer;
}

.receipt-thumb-button:hover {
  border-color: #2563eb;
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.16);
}

:deep(.receipt-thumb-img) {
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.receipt-viewer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1080;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(4px);
}

.receipt-viewer {
  width: min(920px, 100%);
  max-height: min(90dvh, 820px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.88);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.32);
}

.receipt-viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.receipt-eyebrow {
  color: #64748b;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.receipt-title {
  color: #111827;
  font-size: 1rem;
  font-weight: 800;
}

.receipt-close {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  color: #111827;
  background: #ffffff;
}

.receipt-close:hover {
  border-color: #111827;
  background: #111827;
  color: #ffffff;
}

.receipt-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px;
  color: #334155;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
  font-size: 0.82rem;
  font-weight: 600;
}

.receipt-meta span {
  padding: 4px 8px;
  border-radius: 999px;
  background: #eef2f7;
}

.receipt-image-shell {
  min-height: 0;
  overflow: auto;
  padding: 16px;
  background: #111827;
  text-align: center;
}

:deep(.receipt-full-img) {
  max-width: 100%;
  max-height: calc(90dvh - 170px);
  object-fit: contain;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.28);
}

@media (min-width: 992px) {
  .modal-dialog-scrollable .modal-content {
    height: min(760px, calc(100dvh - 1rem));
    max-height: calc(100dvh - 1rem);
  }

  .modal-dialog-scrollable .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-header {
    align-items: flex-start;
  }

  .modal-actions {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl,
  .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }

  .accordion-body {
    padding-inline: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-dialog {
    max-width: calc(100vw - 0.75rem);
    width: calc(100vw - 0.75rem);
    min-height: calc(100dvh - 0.75rem);
    margin: 0.375rem auto;
  }

  .modal-content {
    height: calc(100dvh - 0.75rem);
    max-height: calc(100dvh - 0.75rem);
    border-radius: 18px;
  }

  .modal-header {
    flex-direction: column;
  }

  .modal-actions {
    width: 100%;
  }

  .modal-actions .btn-resumen-primary {
    flex: 1 1 150px;
  }

  .modal-header .btn-close {
    align-self: flex-end;
  }

  .modal-body {
    padding: 12px;
  }

  .modal-footer {
    justify-content: stretch;
  }

  .modal-footer .btn {
    flex: 1 1 140px;
  }

  .pagado {
    align-items: flex-start !important;
    flex-direction: column;
  }

  .pagado p {
    text-align: left;
  }
}
</style>
